<template>
  <div class="tilte-list">
    <img :src="require('@/assets/daping/point-left.png')" class="point-left" />
    <div class="title-name">
      {{ titleName }}
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  props: {
    titleName: {
      type: String,
      default: "",
    },
    imgShort: {
      type: String,
      default: "0",
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.tilte-list {
  display: flex;
  align-items: center;
  .point-left {
    width: 56px;
  }
  .title-name {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 24px;
    color: #f3f8ff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    
    background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/title-internal.vue